export default "__VITE_ASSET__7mfYlR3k__"